
/**
 * useAnalytics - A simple hook for Google Analytics event tracking.
 * Usage: const { trackEvent } = useAnalytics(); trackEvent('Category', 'Action', 'Label');
 */
export const useAnalytics = () => {
  const trackEvent = (eventName: string, params?: Record<string, any>) => {
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", eventName, params || {});
    }
  };
  return { trackEvent };
};
